import ageviaLogo from 'assets/images/agevia-logo.png'
import ayahpathIcon from 'assets/images/ayahpath-icon.png'
import ayahpathLogo from 'assets/images/ayahpath-logo.png'
import blessedpathIcon from 'assets/images/blessedpath-icon.png'
import blessedpathLogo from 'assets/images/blessedpath-logo.png'
import cardimateIcon from 'assets/images/cardimate-icon.png'
import cardimateLogo from 'assets/images/cardimate-logo.png'
import dancebitIcon from 'assets/images/dancebit-icon.png'
import dancebitLogo from 'assets/images/dancebit-logo.png'
import deeplyLogo from 'assets/images/deeply-logo.png'
import dumkaLogo from 'assets/images/dumka-logo.png'
import famioIcon from 'assets/images/famio-icon.png'
import famioLogo from 'assets/images/famio-logo.png'
import pianoIcon from 'assets/images/favicon-hello-piano.png'
import fitmeLogo from 'assets/images/fitme-icon.webp'
import fitmeIcon from 'assets/images/fitme-logo.webp'
import pianoLogo from 'assets/images/hello-piano-logo.png'
import karmapathIcon from 'assets/images/karmapath-icon.png'
import karmapathLogo from 'assets/images/karmapath-logo.png'
import luvlyIcon from 'assets/images/luvly-icon.png'
import luvlyLogo from 'assets/images/luvly-logo.png'
import meowz8Logo from 'assets/images/meowz-logo.svg'
import mygrowthIcon from 'assets/images/mygrowth-icon.png'
import mygrowthLogo from 'assets/images/mygrowth-logo.png'
import nove8Icon from 'assets/images/nove8-icon.png'
import nutrimateIcon from 'assets/images/nutrimate-icon.png'
import nutrimateLogo from 'assets/images/nutrimate-logo.png'
import nutriWalkingIcon from 'assets/images/nutriwalking-icon.png'
import nutriWalkingLogo from 'assets/images/nutriwalking-logo.png'
import spilioLogo from 'assets/images/spilio-logo.png'
import stylioLogo from 'assets/images/stylio-logo.png'
import testoraIcon from 'assets/images/testora-icon.png'
import testoraLogo from 'assets/images/testora-logo.png'
import upluvIcon from 'assets/images/upluv-icon.png'
import upluvLogo from 'assets/images/upluv-logo.png'
import woofzIcon from 'assets/images/woofz-icon.png'

import { AppName, Color } from 'root-constants'

export const APP_LOGOS = {
  [AppName.LUVLY]: { image: luvlyLogo, width: 66 },
  [AppName.DANCEBIT]: { image: dancebitLogo, width: 54, name: 'Dancebit' },
  [AppName.NUTRIMATE]: { image: nutrimateLogo, width: 114 },
  [AppName.NUTRI_WALKING]: { image: nutriWalkingLogo, width: 144 },
  [AppName.FAMIO]: { image: famioLogo, width: 100 },
  [AppName.UPLUV]: { image: upluvLogo, width: 57 },
  [AppName.WOOFZ]: { image: woofzIcon, width: 36 },
  [AppName.MEOWZ]: {
    image: meowz8Logo,
    width: 36,
    name: 'Meowz: Cat Training & Care',
  },
  [AppName.STYLIO]: { image: stylioLogo, width: 36, name: 'Stylio' },
  [AppName.CARDIMATE]: { image: cardimateLogo, width: 121 },
  [AppName.FITME]: { image: fitmeLogo, width: 75 },
  [AppName.MYGROWTH]: { image: mygrowthLogo, width: 125 },
  [AppName.HELLO_PIANO]: { image: pianoLogo, width: 180 },
  [AppName.AYAHPATH]: { image: ayahpathLogo, width: 121 },
  [AppName.BLESSEDPATH]: { image: blessedpathLogo, width: 137 },
  [AppName.KARMAPATH]: { image: karmapathLogo, width: 121 },
  [AppName.TESTORA]: { image: testoraLogo, width: 192 },
  [AppName.SPILIO]: { image: spilioLogo, width: 90 },
  [AppName.DEEPLY]: { image: deeplyLogo, width: 192 },
  [AppName.AGEVIA]: { image: ageviaLogo, width: 100 },
  [AppName.DUMKA]: { image: dumkaLogo, width: 110 },
}

export const BANNER_LOGOS = {
  [AppName.LUVLY]: {
    image: luvlyIcon,
    name: 'Luvly',
    bgColor: 'linear-gradient(270deg, #99A7CD 0%, #D09EA1 100%)',
  },
  [AppName.DANCEBIT]: {
    image: dancebitIcon,
    name: 'Dancebit',
    bgColor: 'linear-gradient(90deg, #45B5FF 0%, #3B91FF 100%)',
  },
  [AppName.NUTRIMATE]: {
    image: nutrimateIcon,
    name: 'NutriMate',
    bgColor: 'linear-gradient(90deg, #9ACA42 0%, #87BD34 100%)',
  },
  [AppName.NUTRI_WALKING]: {
    image: nutriWalkingIcon,
    name: 'NutriWalking',
    bgColor: 'linear-gradient(90deg, #F1693B 0%, #F37A50 100%)',
  },
  [AppName.FAMIO]: {
    image: famioIcon,
    name: 'Famio',
    bgColor: 'linear-gradient(90deg, #9388FF 0%, #6336FF 100%)',
  },
  [AppName.UPLUV]: {
    image: upluvIcon,
    name: 'UpLuv',
    bgColor: 'linear-gradient(90deg, #71C6FF 0%, #D8A9ED 100%)',
  },
  [AppName.WOOFZ]: {
    image: woofzIcon,
    name: 'Woofz',
    bgColor: '#34B340',
  },
  [AppName.MEOWZ]: {
    image: nove8Icon,
    name: 'Nove8',
    bgColor: '#fff',
  },
  [AppName.STYLIO]: {
    image: stylioLogo,
    name: 'Stylio',
    bgColor: '#fff',
  },
  [AppName.CARDIMATE]: {
    image: cardimateIcon,
    name: 'Cardi Mate',
    bgColor: 'linear-gradient(270deg, #B4CDFB 0%, #94B6F0 100%)',
  },
  [AppName.FITME]: {
    image: fitmeIcon,
    name: 'FitMe',
    bgColor: Color.WHITE,
    textColor: Color.BLACK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.BLACK,
  },
  [AppName.MYGROWTH]: {
    image: mygrowthIcon,
    name: 'MyGrowth',
    bgColor: 'linear-gradient(269deg, #7650F8 -1.43%, #6B44FF 95.51%)',
  },
  [AppName.HELLO_PIANO]: {
    image: pianoIcon,
    name: 'Hello Piano',
    bgColor: 'linear-gradient(90deg, #3E36CA 0%, #47A8FE 100%)',
  },
  [AppName.AYAHPATH]: {
    image: ayahpathIcon,
    name: 'AyahPath',
    bgColor: '#D7DFE5',
    textColor: Color.BLACK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.AYAHPATH,
  },
  [AppName.KARMAPATH]: {
    image: karmapathIcon,
    name: 'KarmaPath',
    bgColor: '#D7DFE5',
    textColor: Color.BLACK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.KARMAPATH,
  },
  [AppName.BLESSEDPATH]: {
    image: blessedpathIcon,
    name: 'BlessedPath',
    bgColor: '#D7DFE5',
    textColor: Color.BLACK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.BLESSEDPATH,
  },
  [AppName.TESTORA]: {
    image: testoraIcon,
    name: 'Testora',
    bgColor: '#D7DFE5',
    textColor: Color.BLACK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.TESTORA,
  },
  [AppName.SPILIO]: {
    image: spilioLogo,
    name: 'Spilio',
    bgColor: '#fff',
    textColor: Color.BLUE_DARK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.SPILIO,
  },
  [AppName.DEEPLY]: {
    image: deeplyLogo,
    name: 'Deeply',
    bgColor: '#fff',
    textColor: Color.BLUE_DARK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.DEEPLY,
  },
  [AppName.AGEVIA]: {
    image: ageviaLogo,
    name: 'Agevia',
    bgColor: '#fff',
    textColor: Color.BLUE_DARK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.BLACK,
  },
  [AppName.DUMKA]: {
    image: dumkaLogo,
    name: 'Dumka',
    bgColor: '#fff',
    textColor: Color.BLUE_DARK,
    buttonTextColor: Color.WHITE,
    buttonBgColor: Color.DUMKA,
  },
}
